export default {
  // Navigation
  'nav.home': 'Home',
  'nav.services': 'Services',
  'nav.register': 'Register',
  'nav.blog': 'Blog',
  'nav.tryFree': 'Try Free',

  // Hero Section
  'hero.title1': 'Complete Control of',
  'hero.title2': 'Your Gym Management',
  'hero.description': 'An integrated management system that provides you with a professional dashboard to track revenues, memberships, attendance, and invoices in one place. With advanced analytical reports for better decision-making.',
  'hero.tryFree': 'Try Free for 14 Days',
  'hero.requestDemo': 'Request Demo',
  'hero.revenue': 'Revenue',
  'hero.totalMemberships': 'Total Memberships',
  'hero.active': 'Active',
  'hero.inactive': 'Inactive',
  'hero.newMemberships': 'New Memberships',
  'hero.thisMonth': 'This month',

  // Why Choose Section
  'whyChoose.title': 'Why Choose 5vix',
  'whyChoose.description': 'An integrated system that meets all your gym needs with an easy-to-use interface and powerful features',
  'whyChoose.timeSaving': 'Save Time',
  'whyChoose.timeSavingDesc': 'Automate daily operations and cut admin tasks by up to 70% so you can focus on growing your business',
  'whyChoose.analytics': 'Smart Analytics',
  'whyChoose.analyticsDesc': 'Get a complete view of your gym performance with detailed reports and customizable dashboards',
  'whyChoose.experience': 'Better Member Experience',
  'whyChoose.experienceDesc': 'Member app for booking classes, tracking progress, and staying connected with trainers',

  // Services Section
  'services.title': 'Everything You Need',
  'services.description': 'A complete toolkit built for gym owners to run their business efficiently',
  'services.membership.title': 'Membership Management',
  'services.membership.description': 'Handle member data, subscriptions, renewals, and expiry notifications effortlessly',
  'services.membership.feature1': 'Custom member profiles',
  'services.membership.feature2': 'Auto-renewal & billing',
  'services.membership.feature3': 'Digital membership cards',
  'services.scheduling.title': 'Class Scheduling',
  'services.scheduling.description': 'Schedule classes, manage trainers, and let members book online',
  'services.scheduling.feature1': 'Drag-and-drop scheduler',
  'services.scheduling.feature2': 'Online booking portal',
  'services.scheduling.feature3': 'Automated reminders',
  'services.payment.title': 'Payments & Invoicing',
  'services.payment.description': 'Accept payments, generate invoices, and track finances in real time',
  'services.payment.feature1': 'Multiple payment methods',
  'services.payment.feature2': 'Auto-generated invoices',
  'services.payment.feature3': 'Tax-ready reports',
  'services.analytics.title': 'Reports & Analytics',
  'services.analytics.description': 'Deep insights into your business with visual dashboards and exportable reports',
  'services.analytics.feature1': 'Revenue & expense tracking',
  'services.analytics.feature2': 'Attendance & retention reports',
  'services.analytics.feature3': 'KPI dashboards',
  'services.memberApp.title': 'Member Mobile App',
  'services.memberApp.description': 'A branded app for your members to book, track, and communicate on the go',
  'services.memberApp.feature1': 'Book classes & PT sessions',
  'services.memberApp.feature2': 'Track goals & progress',
  'services.memberApp.feature3': 'Chat with trainers',
  'services.inventory.title': 'Inventory & POS',
  'services.inventory.description': 'Manage products, track stock, and process sales from one screen',
  'services.inventory.feature1': 'Product catalog',
  'services.inventory.feature2': 'Built-in point of sale',
  'services.inventory.feature3': 'Sales & profit reports',

  // Statistics Section
  'stats.revenue': 'Revenue',
  'stats.netProfit': 'Net Profit',
  'stats.members': 'Members',
  'stats.fromPreviousMonth': 'from previous month',
  'stats.income': 'Income',
  'stats.expenses': 'Expenses',
  'stats.organicSources': 'Traffic Sources',
  'stats.socialMedia': 'Social Media',
  'stats.friends': 'Referrals',
  'stats.directVisit': 'Direct Visit',
  'stats.calls': 'Phone Calls',
  'stats.billingStatus': 'Invoice Status',
  'stats.draft': 'Draft',
  'stats.sent': 'Sent',
  'stats.paid': 'Paid',
  'stats.partiallyPaid': 'Partial',
  'stats.overdue': 'Overdue',
  'stats.cancelled': 'Cancelled',

  // Registration Section
  'register.title1': 'Start Your Journey with',
  'register.title2': '5vix',
  'register.title3': 'Today',
  'register.description': 'Sign up now and get 14 days free. No credit card needed, no strings attached.',
  'register.quickSetup': 'Quick Setup',
  'register.quickSetupDesc': 'Get up and running in minutes with guided onboarding and 24/7 support',
  'register.dataSafe': 'Your Data is Safe',
  'register.dataSafeDesc': 'Bank-level encryption, regular backups, and full data protection compliance',
  'register.support': '24/7 Support',
  'register.supportDesc': 'A dedicated support team ready to help whenever you need it',
  'register.formTitle': 'Create Your Account',
  'register.firstName': 'First Name',
  'register.lastName': 'Last Name',
  'register.gymName': 'Gym Name',
  'register.email': 'Email Address',
  'register.phone': 'Phone Number',
  'register.package': 'Plan',
  'register.selectPackage': 'Select Plan',
  'register.basic': 'Basic',
  'register.professional': 'Professional',
  'register.integrated': 'Integrated',
  'register.createAccount': 'Start via WhatsApp',

  // Testimonials Section
  'testimonials.title': 'Trusted by Gym Owners',
  'testimonials.description': 'Hear from gym owners who run their business with 5vix',
  'testimonials.customer1.name': 'Fahad Jamal',
  'testimonials.customer1.role': 'Owner, Fit Punch Gym',
  'testimonials.customer1.text': 'We have been in the industry for about 6 years and struggled with payroll and attendance. After switching to 5vix, everything became easy to manage from mobile. Support is always quick to resolve any issue.',
  'testimonials.customer2.name': 'Ahmed Khairat',
  'testimonials.customer2.role': 'Owner, Cyborg Calisthenics',
  'testimonials.customer2.text': 'Quality, continuous improvement, and excellent service sum up my experience with 5vix. I recommend anyone looking to grow their gym to start their journey with this platform.',
  'testimonials.customer3.name': 'Abdullah Al-Rashid',
  'testimonials.customer3.role': 'Owner, Power Gym Chain',
  'testimonials.customer3.text': 'Outstanding support and constant updates that add real value. The reports and analytics helped me understand my business better and make smarter strategic decisions.',

  // Blog Section
  'blog.title': 'Fitness & Wellness Blog',
  'blog.description': 'Tips, guides, and insights to help you grow your gym and serve your members better',
  'blog.subtitle': 'Expert tips, guides, and insights to help you achieve your fitness goals',
  'blog.allArticles': 'All Articles',
  'blog.fitness': 'Fitness',
  'blog.nutrition': 'Nutrition',
  'blog.wellness': 'Wellness',
  'blog.training': 'Training',
  'blog.newsletterTitle': 'Stay in the Loop',
  'blog.newsletterDesc': 'Get the latest fitness tips and gym management insights delivered to your inbox',
  'blog.readMore': 'Read More',
  'blog.viewAll': 'View All Articles',

  'blog.article1.title': '10 Strategies to Boost Member Retention',
  'blog.article1.description': 'Discover proven strategies to keep your members engaged and reduce churn rate at your gym.',
  'blog.article1.author': 'Ahmed Al-Shammari',
  'blog.article1.excerpt': 'Discover proven strategies to keep your members engaged, motivated, and loyal to your gym. Learn how top gyms reduce churn and build thriving communities.',
  'blog.article2.title': 'How to Hire the Best Trainers for Your Gym',
  'blog.article2.description': 'A complete guide to finding, hiring, and developing a team of professional trainers.',
  'blog.article2.author': 'Noura Al-Khalidi',
  'blog.article2.excerpt': 'A comprehensive guide to recruiting, vetting, and developing world-class trainers who will elevate your gym experience and keep members coming back.',
  'blog.article3.title': 'Data Analytics: The Key to Gym Success',
  'blog.article3.description': 'How to use data analytics to make better decisions and boost your gym revenue.',
  'blog.article3.author': 'Khaled Al-Saeed',
  'blog.article3.excerpt': 'Learn how leading gym owners use data to optimize pricing, schedule classes smarter, and increase revenue through evidence-based decision making.',
  'blog.article4.title': 'HIIT Training: Benefits and Best Practices',
  'blog.article4.excerpt': 'Explore the science behind high-intensity interval training and how to incorporate it effectively into your fitness routine.',
  'blog.article5.title': 'Home Workout Essentials: No Gym Required',
  'blog.article5.excerpt': 'Get fit from the comfort of your home with these effective exercises and minimal equipment. Perfect for busy schedules.',
  'blog.article6.title': 'Protein Intake: How Much Do You Really Need?',
  'blog.article6.excerpt': 'Debunking myths about protein consumption and providing evidence-based recommendations for different fitness goals.',
  'blog.article7.title': 'Sleep Optimization for Better Performance',
  'blog.article7.excerpt': 'Learn how quality sleep impacts your fitness results and discover strategies to improve your sleep quality.',
  'blog.article8.title': 'Strength Training for Beginners: A Complete Guide',
  'blog.article8.excerpt': 'Everything you need to know to start your strength training journey safely and effectively.',
  'blog.article9.title': 'Flexibility and Mobility: The Missing Link',
  'blog.article9.excerpt': 'Why flexibility training is essential for overall fitness and how to incorporate it into your routine for better results.',

  // CTA Section
  'cta.title': 'Ready to Transform Your Gym?',
  'cta.description': 'Join thousands of gyms using 5vix to streamline operations and deliver an amazing member experience.',
  'cta.button': 'Start Free Today',

  // Footer
  'footer.description': 'An all-in-one gym management platform that helps you organize memberships, schedule classes, track attendance, and analyze performance with ease.',
  'footer.quickLinks': 'Quick Links',
  'footer.support': 'Support',
  'footer.helpCenter': 'Help Center',
  'footer.faq': 'FAQ',
  'footer.contactUs': 'Contact Us',
  'footer.terms': 'Terms & Conditions',
  'footer.privacy': 'Privacy Policy',
  'footer.newsletter': 'Follow us on WhatsApp',
  'footer.newsletterDesc': 'Subscribe to get the latest tips and updates directly on WhatsApp',
  'footer.subscribe': 'Subscribe',
  'footer.whatsappPlaceholder': 'WhatsApp number...',
  'footer.cookies': 'Cookies',
  'footer.copyright': '© 2025 5vix. All rights reserved.',

  // Help Center
  helpCenter: {
    title: 'Help Center',
    subtitle: 'Find answers and get the support you need',
    searchPlaceholder: 'Search for help...',
    gettingStarted: 'Getting Started',
    membership: 'Membership',
    billing: 'Billing',
    technical: 'Technical',
    mobileApp: 'Mobile App',
    reports: 'Reports',
    frequentlyAsked: 'Frequently Asked Questions',
    noResults: 'No results found. Try different keywords.',
    stillNeedHelp: 'Still Need Help?',
    contactTeam: 'Our support team is here for you 24/7',
    whatsappSupport: 'WhatsApp Support',
    callUs: 'Call Us',
    faq1: { question: 'How do I get started with 5vix?', answer: 'Getting started is easy! Sign up for a free trial, complete the quick setup wizard, and start managing your gym right away. Our team will guide you through every step.' },
    faq2: { question: 'What payment methods do you accept?', answer: 'We accept all major credit cards (Visa, Mastercard, American Express), PayPal, and bank transfers. All payments are processed securely through our encrypted gateway.' },
    faq3: { question: 'How do I add new members?', answer: 'Go to the Members section in your dashboard, click "Add Member", fill in their details, select a membership plan, and process the payment. Members receive a welcome email automatically.' },
    faq4: { question: 'Can members book classes through the mobile app?', answer: 'Yes! Members can download our app, log in, and book classes, view schedules, track progress, and manage their membership directly from their phone.' },
    faq5: { question: 'How do I set up recurring billing?', answer: 'Recurring billing is set up automatically when you create a membership plan. Configure the frequency (monthly, quarterly, annually) and the system handles the rest.' },
    faq6: { question: 'What happens if a payment fails?', answer: 'The system automatically retries after 3 days. Members get email notifications about failed payments. You can also manually process payments from the member profile.' },
    faq7: { question: 'How do I integrate with my existing systems?', answer: '5vix offers API access and supports various third-party integrations. Contact our technical team to discuss your specific needs.' },
    faq8: { question: 'Is my data secure?', answer: 'Absolutely. We use bank-level encryption (SSL/TLS), secure data centers with 24/7 monitoring, regular backups, and full compliance with data protection standards.' },
    faq9: { question: 'How do I download the mobile app?', answer: 'The 5vix app is available on iOS and Android. Search "5vix" in the App Store or Google Play Store, or visit our website for direct download links.' },
    faq10: { question: 'Can I customize the mobile app branding?', answer: 'Yes! On Professional and Integrated plans, you can customize the app with your gym logo, colors, and branding. Contact support to set it up.' },
    faq11: { question: 'What reports are available?', answer: 'We offer revenue analysis, membership stats, attendance tracking, class popularity, trainer performance, and custom reports. All exportable to PDF or Excel.' },
    faq12: { question: 'Can I schedule automated reports?', answer: 'Yes! Schedule reports to be automatically generated and emailed daily, weekly, or monthly from the Reports section.' },
  },

  // Terms
  terms: {
    title: 'Terms and Conditions',
    lastUpdated: 'Last Updated: January 2025',
    section1: { title: '1. Acceptance of Terms', content1: 'By accessing and using the 5vix gym management system, you agree to be bound by these Terms and Conditions. If you do not agree, you may not use our services.', content2: 'These terms apply to all users including gym owners, administrators, trainers, and members.' },
    section2: { title: '2. User Accounts and Registration', content: 'To use our services, you must:', item1: 'Provide accurate and complete registration information', item2: 'Maintain the security of your account credentials', item3: 'Notify us immediately of any unauthorized access', item4: 'Be responsible for all activities under your account' },
    section3: { title: '3. Service Description', content: '5vix provides a comprehensive gym management platform including:', item1: 'Member management and tracking', item2: 'Class scheduling and booking', item3: 'Payment processing and billing', item4: 'Performance analytics and reporting', item5: 'Mobile app access for members and staff' },
    section4: { title: '4. Payment Terms', content1: 'Subscription fees are billed in advance monthly or annually. All fees are non-refundable except as required by law.', content2: 'You authorize us to charge your payment method. If payment fails, we may suspend or terminate your access.' },
    section5: { title: '5. User Responsibilities', content: 'Users agree to:', item1: 'Use the service only for lawful purposes', item2: 'Not interfere with or disrupt the service', item3: 'Not attempt unauthorized access to any part of the system', item4: 'Comply with all applicable laws and regulations' },
    section6: { title: '6. Intellectual Property', content: 'All content, features, and functionality of the 5vix platform are owned by us and protected by international copyright, trademark, and intellectual property laws.' },
    section7: { title: '7. Limitation of Liability', content: 'To the maximum extent permitted by law, 5vix shall not be liable for any indirect, incidental, special, consequential, or punitive damages.' },
    section8: { title: '8. Contact Information', content: 'If you have questions about these Terms, contact us:', whatsapp: 'WhatsApp:', phone: 'Phone:' },
    cta: { title: 'Ready to Get Started?', subtitle: 'Join thousands of gyms using 5vix to manage their business', helpCenter: 'Visit Help Center' },
  },

  // Privacy
  privacy: {
    title: 'Privacy Policy',
    lastUpdated: 'Last Updated: January 2024',
    introduction: 'At 5vix, we are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information.',
    section1: { title: '1. Information We Collect', subtitle1: 'Personal Information', content1: 'We collect information you provide directly: name, email, phone, date of birth, payment info, and gym membership details.', subtitle2: 'Usage Information', content2: 'We automatically collect data about your use of our services: login times, features accessed, workout data, attendance records, and device info.', subtitle3: 'Health and Fitness Data', content3: 'With your consent, we may collect health-related data such as workout routines, body measurements, fitness goals, and progress tracking.' },
    section2: { title: '2. How We Use Your Information', content: 'We use collected information for:', item1: 'Providing, maintaining, and improving our services', item2: 'Processing membership payments and managing your account', item3: 'Sending important updates, notifications, and promotional materials', item4: 'Personalizing your experience with customized recommendations', item5: 'Analyzing usage patterns to improve platform performance' },
    section3: { title: '3. Information Sharing', content: 'We do not sell, trade, or rent your personal information. We share only: with your consent, to comply with legal obligations, to protect our rights, or with service providers under strict confidentiality.' },
    section4: { title: '4. Data Security', content: 'We implement industry-standard security: encryption, secure servers, regular audits, and access controls. No internet transmission is 100% secure, and we cannot guarantee absolute security.' },
    section5: { title: '5. Cookies and Tracking', content: 'We use cookies to enhance your experience, remember preferences, analyze traffic, and personalize content. You can control cookie settings through your browser.' },
    section6: { title: '6. Your Rights', content: 'You have the right to:', item1: 'Access and review your personal data', item2: 'Request correction of inaccurate information', item3: 'Request deletion of your data (subject to legal requirements)', item4: 'Opt-out of marketing communications anytime' },
    section7: { title: '7. Third-Party Links', content: 'Our platform may link to third-party sites. We are not responsible for their privacy practices. Please review their policies.' },
    section8: { title: '8. Changes to This Policy', content: 'We may update this policy to reflect changes in practices or legal requirements. We will notify you of material changes by posting the updated policy and updating the "Last Updated" date.' },
    section9: { title: 'Contact Us', content: 'If you have questions about this Privacy Policy, contact us:' },
    cta: { title: 'Ready to Get Started?', subtitle: 'Join thousands using 5vix to achieve their fitness goals', button: 'Start Free Trial' },
  },

  // Misc
  'mobile.close': 'Close',
};